/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

export const reorder = (
    list,
    startIndex,
    endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    if( typeof result[0].sequence === 'number'){
        return fixSequence(result);
    }else{
        return result;
    }
};

const fixSequence = (list) => {
    for ( let i = 0; i < list.length ; i ++){
        list[i].sequence = i;
    }
    return list;
};

export const reorderResourceInstances = ({resource,source,destination,titles}) => {
    const current = [...resource[source.droppableId].resourceData];
    const next = [...resource[destination.droppableId].resourceData];
    const target = current[source.index];

    // moving to same list
    if (source.droppableId === destination.droppableId) {
        const reordered = reorder(
            current,
            source.index,
            destination.index,
        );
        const result = {...resource};

        result[source.droppableId].resourceData =  reordered;

        return {
            resource: result
        };
    }
    // moving to different list
    // remove from original
    current.splice(source.index, 1);
    // insert into next
    next.splice(destination.index, 0, target);
    const length = current.length;
    if (length === 0) {
        delete resource[source.droppableId];
        for (let i = 0; i < titles.length; i++ ){
            if(titles[i] === source.droppableId ){
                titles.splice(i, 1);
            }
        }
    }
    const result = {
        ...resource,

    };

    if (result[source.droppableId]){
        result[source.droppableId].resourceData = fixSequence(current);
    }
    result[destination.droppableId].resourceData = fixSequence(next);

    return {
        resource: result,
        titles: titles
    };
};

export const reArrange = (data) => {
    const dataCopy = JSON.parse(JSON.stringify(data));
    let formatedData = {};

    dataCopy.map((chapter , index) => {
        formatedData[chapter.title+" "+index] = {"resourceData":chapter.resourceInstances, "chapterId":chapter.chapterId ? chapter.chapterId : null};
    });

    return formatedData;
};

export const titleArray = data => {
    let newData = {};
    data.map((chapter, index) => {
        newData[chapter.title+" "+index] = chapter.chapterId;
    });
    return newData;
};

export const buildChapterPayload = (data) => {
    const payload = [];
    data.titles.map((title, index)=>{
        let resources = [];
        data.columns[title].resourceData.map((chapters)=>{
            let resourceInstance = {
                resourceInstanceId: chapters.resourceInstanceId,
                sequence: chapters.sequence
            };
            resources.push(resourceInstance);
        });
        let chapter = {
            chapterId : data.chapterId[title],
            resourceInstances: resources,
            sequence: index
        };
        payload.push(chapter);
    });
    return payload;
};

export const getChapterId = (data , key) => {
    const chapterId = data[key];
    return chapterId;
};



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/ComponentPageComponents/HelperMethods/DragAndDropHelper.js